// src/App.js

import React from "react";
import { BrowserRouter } from "react-router-dom";
import RouterWrapper from "./router/RouterWrapper";
import ErrorBoundary from "../../shared/components/ErrorBoundary/ErrorBoundary";
import LoadingWrapper from "../../shared/components/LoadingWrapper/LoadingWrapper";
import { MobileDetectionWrapper } from "../../shared/components/IsMobileWrapper/IsMobileWrapper";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <LoadingWrapper>
          <MobileDetectionWrapper>
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            >
              <RouterWrapper />
            </GoogleReCaptchaProvider>
          </MobileDetectionWrapper>
        </LoadingWrapper>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
